import {BaseSlider} from "./BaseSlider";

export class PackageSlider extends BaseSlider {
    constructor() {
        super('.swiper-package');

        let maxItems = document.querySelectorAll('.swiper-package .swiper-slide').length;
        if (maxItems === 0) {
            maxItems = 6;
        }

        this.baseSwiperOptions.breakpoints = {
            768: {
                slidesPerView: 2,
                viewport: 'sm'
            },
            992: {
                slidesPerView: 3,
                viewport: 'md'
            },
            1300: {
                slidesPerView: maxItems,
                viewport: 'lg'
            }
        }

        this.initSlider();
        if (this.swiperElement) {
            this.initViewportEvents();
        }
    }

    initViewportEvents() {
        this.hideMoreFeatures();
        this.isSliderReset = false;

        // have to reset the loop index to avoid different order of elements after slider was disabled
        this.swiper.on('resize', (swiper) => {
            if (window.innerWidth >= 1290 && !this.isSliderReset) {
                swiper.slideToLoop(0, 0, false);
                this.isSliderReset = true;
            } else {
                this.isSliderReset = false;
            }
        });
    }

    hideMoreFeatures() {
        const showMoreText = document.querySelector('.swiper-package').dataset.showMore ?? '';
        const showLessText = document.querySelector('.swiper-package').dataset.showLess ?? '';

        this.swiperElement.querySelectorAll('.pricetbl_container').forEach(container => {
            let featureIndex = 0;
            container.querySelectorAll('.pricetbl_packagedesc').forEach(feature => {
                featureIndex++;
                if (featureIndex > 1) {
                    feature.classList.add('c-slide-package-feature', 'c-slide-package-feature--hidden');
                }
            });

            if (featureIndex > 1 && container.querySelector('.c-slide-package-show-more') === null) {
                let showMoreElement = document.createElement('a');
                showMoreElement.classList.add('c-slide-package-show-more');
                showMoreElement.href = '#';
                showMoreElement.textContent = showMoreText;
                showMoreElement.dataset.hidden = '1';

                container.append(showMoreElement);

                showMoreElement.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (showMoreElement.dataset.hidden === '1') {
                        showMoreElement.dataset.hidden = '0';
                        showMoreElement.textContent = showLessText;
                        showMoreElement.classList.add('c-slide-package-show-more--active');
                        container.querySelectorAll('.c-slide-package-feature--hidden').forEach(feature => {
                            feature.classList.remove('c-slide-package-feature--hidden');
                            feature.classList.add('c-slide-package-feature--visible');
                        });
                    } else {
                        showMoreElement.dataset.hidden = '1';
                        showMoreElement.textContent = showMoreText;
                        showMoreElement.classList.remove('c-slide-package-show-more--active');
                        container.querySelectorAll('.c-slide-package-feature--visible').forEach(feature => {
                            feature.classList.remove('c-slide-package-feature--visible');
                            feature.classList.add('c-slide-package-feature--hidden');
                        });
                        container.scrollIntoView({ behavior: "smooth"});
                    }
                });
            }
        });
    }
}